var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Box from "./Box";
import { Row, Col } from "reactstrap";
import { EQUALIZER_SVG, PLAY_SMALL_SVG, PAUSE_SMALL_SVG } from "../assets";
import { PlayerContextConsumer } from "../context/player";
import { AddToHistory, PlayerState } from "../player/types";
import PlaybackManager from "../player/PlaybackManager";
import DynamicPlaylist from "../player/DynamicPlaylist";
import { messages } from "../messages";
var Top10 = /** @class */ (function (_super) {
    __extends(Top10, _super);
    function Top10(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, _this.props.context, false);
        _this.internallist.replace(_this.props.albums.map(function (album) {
            return {
                album: album,
                track: album.media[0],
                playbackInfo: album.media[0].stream_info,
                playlist: _this.internallist
            };
        }));
        return _this;
    }
    Top10.prototype.componentDidUpdate = function (nextProps) {
        var _this = this;
        if (nextProps.albums != this.props.albums)
            this.internallist.replace(this.props.albums.map(function (album) {
                return {
                    album: album,
                    track: album.media[0],
                    playbackInfo: album.media[0].stream_info,
                    playlist: _this.internallist
                };
            }));
    };
    Top10.prototype.onAlbumSelected = function (album) {
        PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
        PlaybackManager.getInstance().startTrack(this.internallist.tracks().find(function (a) { return a.album.id == album.id; }));
    };
    Top10.prototype.onPause = function () {
        PlaybackManager.getInstance().pause();
    };
    Top10.prototype.render = function () {
        var _this = this;
        return (React.createElement(Box, { style: this.props.style, className: 'top10-view listview' },
            React.createElement("h3", { style: { marginBottom: 34 } }, messages.Top10),
            React.createElement(PlayerContextConsumer, null, function (playingSong) {
                return React.createElement("div", null, _this.props.albums.map(function (value, index) {
                    var isPlaying = playingSong.state == PlayerState.Playing && playingSong.track && playingSong.track.album.id == value.id;
                    return (React.createElement("div", { key: value.id, className: 'top10-container' },
                        React.createElement(Row, { className: 'title-row' },
                            React.createElement(Col, { className: "count-col", onClick: function () { return isPlaying ? _this.onPause() : _this.onAlbumSelected(value); } },
                                React.createElement(Row, null,
                                    React.createElement("span", { className: 'count-text' }, index + 1),
                                    !isPlaying && React.createElement("img", { src: PLAY_SMALL_SVG, alt: "play_Button", width: 10 }),
                                    isPlaying &&
                                        React.createElement("img", { className: 'play_Button', src: PAUSE_SMALL_SVG, alt: "pause", width: 10 }))),
                            React.createElement(Col, { className: "track-col", onClick: function () { return _this.props.onAlbumClick && _this.props.onAlbumClick(value); } },
                                React.createElement(Row, null,
                                    React.createElement("div", { className: 'title-col ' + (isPlaying ? 'playing' : '') }, value.name)),
                                React.createElement(Row, null,
                                    React.createElement("div", { className: 'artist-col' }, value.artist))),
                            React.createElement(Col, { className: "equalizer-col" },
                                React.createElement(Row, null,
                                    React.createElement("div", { style: { marginRight: 10 } }, isPlaying &&
                                        React.createElement("img", { className: 'equalizer', src: EQUALIZER_SVG, alt: "equalizer" })))))));
                }));
            })));
    };
    return Top10;
}(React.PureComponent));
export default Top10;
//# sourceMappingURL=Top10.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/Top10.js
// module id = 1296
// module chunks = 0